// extracted by mini-css-extract-plugin
export var compactFilters = "_dc-4";
export var detailImage = "_dc-1";
export var dropdownContainer = "_dc-2";
export var imageContainer = "_dc-0";
export var selectedCard = "_dc-3";